import {
  Box,
  Button,
  Stack,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import Iconify from "../iconify/iconify";
import { useTheme } from "@emotion/react";
import { LayoutContainer } from "../app-layoout/container";
const StyledSearchBox = styled(Box)(({ theme }) => ({
  padding: "10px ",
  width: "70%",
  margin: "0 auto",
  position: "absolute",
  bottom: "50px",
  borderRadius: "10px",
  background: theme.palette.background.main,
  left: 0,
  right: 0,
  display: "flex",
  fieldset: {
    border: `1px solid ${theme.palette.divider} !important`,
  },
  input: {
    paddingRight: "165px",
    "&::placeholder": {
      color: theme.palette.text.primary,
    },
  },
  [theme.breakpoints.down("sm")]: {
    position: "absolute",
    bottom: "310px",
    width: "auto",
    input: {
      paddingRight: "82px ",
    },
  },
  [theme.breakpoints.down("md")]: {
    position: "absolute",
    bottom: "310px",
    width: "auto",
    input: {
      paddingRight: "82px ",
    },
  },
}));

const StyledWrapperBox = styled(Box)(({ theme }) => ({
  background: theme.palette.background.main,
  padding: "10px",
  borderRadius: "10px",
  position: "relative",
}));
export const SearchPropeties = ({ dataListPropertiesQuery }) => {
  const theme = useTheme();

  const [search, setSearch] = React.useState("");
  const handleSubmit = async (e) => {
    e.preventDefault(); // Evita que se recargue la página
    dataListPropertiesQuery.searchName(search);
  };
  return (
    <LayoutContainer>
      <Stack pt={{ xs: 13, md: 4 }}>
        <StyledWrapperBox>
          <form onSubmit={handleSubmit} sx={{ width: "100%" }}>
            {" "}
            <StyledSearchBox>
              <TextField
                id="search-property"
                placeholder="Buscar una propiedad"
                fullWidth
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                value={search}
                sx={{
                  background: theme.palette.background.default,
                  borderRadius: "10px",
                }}
              />

              <Box
                sx={{
                  position: "absolute",
                  right: "20px",
                  top: "18px",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<Iconify icon="fluent:search-12-filled" />}
                  type="submit"
                  sx={{
                    display: { xs: "none", md: "flex" },
                    backgroundColor: "#a95052",
                    "&:hover": { backgroundColor: "#8c3e47" },
                  }}
                >
                  Buscar Propiedad
                </Button>
                <Button
                  sx={{ display: { xs: "flex", md: "none" } }}
                  type="submit"
                >
                  <Iconify icon="fluent:search-12-filled" />
                </Button>
              </Box>
            </StyledSearchBox>
          </form>

          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent={{
              xs: "center",
              md: "center",
              lg: "center",
              xl: "center",
            }}
            alignContent={{
              xs: "center",
              md: "center",
              lg: "center",
              xl: "center",
            }}
            gap={5}
            flexWrap="wrap"
          >
            <Typography
              variant="h6"
              color={
                dataListPropertiesQuery.type === "all"
                  ? "primary.main"
                  : "text.secondary"
              }
              mb={2}
              sx={{
                cursor: "pointer",
                ":hover": { color: "primary.main" },
              }}
              onClick={() => {
                dataListPropertiesQuery.searchType("all");
                setSearch("");
              }}
            >
              Todas
            </Typography>
            <Typography
              variant="h6"
              color={
                dataListPropertiesQuery.type === "normal"
                  ? "primary.main"
                  : "text.secondary"
              }
              mb={2}
              sx={{
                cursor: "pointer",
                ":hover": { color: "primary.main" },
              }}
              onClick={() => {
                dataListPropertiesQuery.searchType("normal");
                setSearch("");
              }}
            >
              Inventario
            </Typography>
            <Typography
              variant="h6"
              color={
                dataListPropertiesQuery.type === "ido"
                  ? "primary.main"
                  : "text.secondary"
              }
              mb={2}
              sx={{
                cursor: "pointer",
                ":hover": { color: "primary.main" },
              }}
              onClick={() => {
                dataListPropertiesQuery.searchType("ido");
                setSearch(undefined);
              }}
            >
              IDO
            </Typography>
            <Typography
              variant="h6"
              color={
                dataListPropertiesQuery.type === "tokenize"
                  ? "primary.main"
                  : "text.secondary"
              }
              mb={2}
              sx={{
                cursor: "pointer",
                ":hover": { color: "primary.main" },
              }}
              onClick={() => {
                dataListPropertiesQuery.searchType("tokenize");
                setSearch("");
              }}
            >
              Tokenizacion
            </Typography>
            {/*  <CustomIconSelect
          data={[
            {
              label: "Todas",
              value: "Todas",
            },
            {
              label: "Normal",
              value: "Normal",
            },
            {
              label: "Tokenizacion",
              value: "Tokenizacion",
            },

            {
              label: "IDO",
              value: "Ido",
            },
          ]}
          icon="ic:outline-maps-home-work"
          placeholder="Tipo de Propiedad"
        /> */}

            {/* <CustomIconSelect
          data={[]}
          icon="ic:outline-maps-home-work"
          placeholder="Property Type"
        />

        <CustomIconSelect
          data={[]}
          icon="material-symbols:price-change-outline"
          placeholder="Pricing Range "
        />

        <CustomIconSelect
          data={[]}
          icon="bi:box"
          placeholder="Property Size"
        />

        <CustomIconSelect
          data={[]}
          icon="clarity:date-solid"
          placeholder="Build Year"
        /> */}
          </Stack>
        </StyledWrapperBox>
      </Stack>
    </LayoutContainer>
  );
};
